import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateTicketById } from '../../../../../../../app/store/slices/ticket/ticket';

export default function useMarkTicketSoldOut() {
    const dispatch = useDispatch();
    const [selectedTicketId, setSelectedTicketId] = useState(null);
    const [openSoldOutDialog, setOpenSoldOutDialog] = useState(false);

    async function markTicketSoldOut() {
        try {
            await dispatch(
                updateTicketById({
                    ticketId: selectedTicketId,
                    ticketData: {
                        sale_status: 'sold_out'
                    }
                })
            ).unwrap();
            setOpenSoldOutDialog(false);
        } catch (error) {
            console.error('Error marking ticket as sold out:', error);
        }
    }

    function handleOpenSoldOutDialog(ticketId) {
        setSelectedTicketId(ticketId);
        setOpenSoldOutDialog(true);
    }

    function handleCloseSoldOutDialog() {
        setOpenSoldOutDialog(false);
        setSelectedTicketId(null);
    }

    return {
        openSoldOutDialog,
        markTicketSoldOut,
        handleOpenSoldOutDialog,
        handleCloseSoldOutDialog
    };
}
